/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BundleGroup } from '../../models/bundle-group';
import { BundleGroupCreateRequest } from '../../models/bundle-group-create-request';
import { KeyType } from '../../models/key-type';

export interface CreateBundleGroup$Params {
  organizationSiteKey: KeyType;
      body: BundleGroupCreateRequest
}

export function createBundleGroup(http: HttpClient, rootUrl: string, params: CreateBundleGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<BundleGroup>> {
  const rb = new RequestBuilder(rootUrl, createBundleGroup.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BundleGroup>;
    })
  );
}

createBundleGroup.PATH = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups';
